import { render, staticRenderFns } from "./CandlesHome.vue?vue&type=template&id=19113028"
import script from "./CandlesHome.vue?vue&type=script&lang=js"
export * from "./CandlesHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports